const supportedLanguages = [
  {
    key: "en",
    value: "English",
  },
  {
    key: "tr",
    value: "Türkçe",
  },
  {
    key: "es",
    value: "Español",
  },
  {
    key: "pt",
    value: "Português",
  },
  {
    key: "pt_BR",
    value: "Português Brasileiro"
  },
  {
    key: "it",
    value: "Italiano",
  },
  {
    key: "de",
    value: "Deutsch",
  },
  {
    key: "fr",
    value: "Français",
  },
  {
    key: "el",
    value: "Ελληνικά",
  },
  {
    key: "sr",
    value: "Srpski",
  },
  {
    key: "nl",
    value: "Nederlands",
  },
  {
    key: "hu",
    value: "Magyar",
  },
  {
    key: "th",
    value: "ภาษาอังกฤษ",
  }
];

export default supportedLanguages;
